import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_HOMEPAGE_V2 = defineFcm('starfish_homepage_v2')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				isEnabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault({
		isEnabled: false,
		experimentName: 'starfish_homepage_v2_release_3',
	})
	.withMerger(({ countryValue, localeValue, globalValue }) => {
		return {
			isEnabled: localeValue.isEnabled || countryValue.isEnabled || globalValue.isEnabled,
			experimentName: localeValue.experimentName || countryValue.experimentName || globalValue.experimentName,
		};
	})
	.toConfig({
		owner: 'squad-starfish',
		scope: 'TBD',
		context: 'Starfish Homepage V2',
		description:
			'Homepage V2 enabled boolean for homepage relaunch. This FCM takes precedence over the starfish_homepage_v2_content FCM.',
		mergeLogic: 'Requires both country and locale to be enabled and have the same experiment name.',
		import: false,
		template: {
			isEnabled: true,
			experimentName: 'starfish_homepage_v2',
		},
		deprecated: 'No references found. Safe to delete after 2026-09-01.',
	});
